import type { Resource } from '../../';
export const country_countries_JE: Resource = {"default":"Jersey"};
